const Live = () => {
  return (
    <div className="h-5 w-9 p-0.5 mb-0.5 bg-red text-white rounded-sm text-xs text-center text-bold animate-[live_2.5s_ease-in-out_infinite]">
      LIVE
    </div>
  );
};

export default Live;
